import styled from 'styled-components'

const SearchWrapper = styled.div`
    display: flex;
    padding: 10px;
`

const SearchInput = styled.input`
    flex: 1 1 auto;
    border: 1px solid #fecad8;
    border-radius: 5px;
    height: 44px;
    font-weight: normal;
    font-size: 14px;
    padding: 0px 15px;
    -webkit-appearance: none;
    @media screen and (max-width: 767px) {
        font-size: 16px;
    }
`

const SearchButton = styled.button`
    margin-left: 10px;
    border: none;
    background: #f84f7f;
    color: #FFF;
    padding: 6px 10px;
    border-radius: 5px;
`

const UserLine = styled.div`
    height: 62px;
    &:hover {
        background-color: #ededed !important;
    }
`

const ContentContainer = styled.div`
    height: calc(100% - 61px);
`

const RegistrationIcon = styled.div`
    width: 44px;
    height: 44px;
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #f84f7f;
    border-radius: 50%;
    color: #f84f7f;
    box-shadow: 0px 0px 4px #f84f7f;
`

const ReadIcon = styled.span`
    color: #28a745;
    width: 14px;
    height: 14px;
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    margin-right: 4px;
    svg {
        width: 100%;
        height: 100%;
    }
`

const LastMessageAt = styled.div`
    flex: 0 0 auto;
    margin-left: 8px;
    align-self: flex-start;
    padding-top: 1px;
    font-size: 11px;
    font-weight: 500;
    color: #adb2ba;
    white-space: nowrap;
`

const FilterContainer = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    padding: 6px 8px 0px 8px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
`

const FilterIcon = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 18px;
    line-height: 1;

    svg {
        width: 18px;
        height: 18px;
        display: block;
    }
`

const FilterLabel = styled.span`
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.2px;
    line-height: 1;
    white-space: normal;
    text-align: center;
    padding-bottom: 7px;
    border-bottom: 2px solid transparent;
    transition: border-color 0.15s ease;
`

const FilterItem = styled.div`
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 7px;
    padding: 9px 2px 0px 2px;
    color: ${props => props.active ? 'var(--pink)' : '#9a9a9a'};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;

    ${FilterLabel} {
        border-bottom-color: ${props => props.active ? 'var(--pink)' : 'transparent'};
    }

    &:hover {
        color: var(--pink);
    }
`

const FilterEmpty = styled.div`
    padding: 25px 10px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #7f7777;
    svg {
        width: 34px;
        height: 34px;
        margin-bottom: 10px;
        opacity: 0.7;
    }
`

const FilterCount = styled.span`
    position: absolute;
    top: -8px;
    right: -10px;
    min-width: 14px;
    height: 14px;
    padding: 0px 3px;
    background: #f84f7f;
    color: #FFF;
    border: 1.5px solid #fff;
    border-radius: 7px;
    font-size: 8px;
    font-weight: 600;
    line-height: 11px;
    text-align: center;
    z-index: 1;
`

export { 
    SearchWrapper,
    SearchInput,
    SearchButton,
    UserLine,
    ContentContainer,
    RegistrationIcon,
    ReadIcon,
    LastMessageAt, FilterContainer,
    FilterItem, FilterIcon, FilterLabel, FilterEmpty, FilterCount
}